import React from 'react';
import { Spinner } from 'reactstrap';
import { Action } from '~/lib/ApiModel';
import { observer } from 'mobx-react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import LabelledProgress from '~/components/LabelledProgress';
import './Actions.scss';

dayjs.extend(relativeTime);
type ActionStepStatus = 'in-progress' | 'queued' | 'completed' | 'errored';

export const StatusIndicator = ({ status }: { status: ActionStepStatus }) => {
    switch (status) {
        case 'errored':
            return (
                <span className="actionStatusIcon text-danger">
                    <i className="icon ion-md-alert" />
                </span>
            );
        case 'completed':
            return (
                <span className="actionStatusIcon text-success">
                    <i className="icon ion-md-checkmark" />
                </span>
            );
        case 'in-progress':
            return (
                <span className="actionStatusIcon text-info">
                    <Spinner size="sm" />
                </span>
            );
        case 'queued':
            return (
                <span className="actionStatusIcon">
                    <i className="icon ion-md-hourglass" />
                </span>
            );
    }
};

type ActionStepProps = {
    status: ActionStepStatus;
    children?: React.ReactNode;
};

export class ActionStep extends React.Component<ActionStepProps> {
    render() {
        return (
            <div className="actionStep">
                <StatusIndicator status={this.props.status} /> {this.props.children}
            </div>
        );
    }
}

@observer
export class ActionStepProgress extends React.Component<{ action: Action }> {
    render() {
        const { action } = this.props;
        return (
            <LabelledProgress label={`${action.title} progress`} value={action.progress.percent_complete} max="100">
                {action.progress.percent_complete}%
            </LabelledProgress>
        );
    }
}

@observer
export class ActionSteps extends React.Component<{ action: Action }> {
    render() {
        const { action } = this.props;
        const completedSteps = action.progress.completed_steps.concat(
            action.status === 'completed' ? [`${this.props.action.title} complete`] : []
        );
        return (
            <>
                {completedSteps.map((s) => (
                    <ActionStep key={s} status="completed">
                        {s}
                    </ActionStep>
                ))}

                {action.progress.current_step && (
                    <ActionStep
                        status={
                            action.status === 'in-progress'
                                ? 'queued'
                                : action.status === 'completed'
                                  ? 'completed'
                                  : 'errored'
                        }
                    >
                        {action.progress.current_step}
                    </ActionStep>
                )}
            </>
        );
    }
}
